import styled from 'styled-components';

export const SectionDescription = styled.div`
  color: ${Styles.color.white};
  text-align: center;
  margin: 1rem 0;

  ${Styles.mobileTiny`
    font-size: 0.875rem;
  `}

  ${Styles.desktop`
    margin-bottom: 4rem;
  `}
`;

export default SectionDescription;
